// En desarrollo local, usar rutas relativas para que el proxy funcione
// En producción, usar las URLs completas del config.js
const isDevelopment = process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost';

export const API_BASE_URL = isDevelopment ? '/api' : window.MAIN_API_URL;
export const CMS_API_URL = isDevelopment ? '/cms' : window.CMS_API_URL;
export const CMS_URL = window.CMS_URL || '*';
export const SEPOMEX_API_URL = window.SEPOMEX_API_URL || 'https://sepomex.icalialabs.com/api/v1/';
